/* Romeo Kids — Ceremonias · Vanilla JS compartido
   Sin dependencias externas.
   Inicializa: scroll-reveal, FAQ accordion, tabs, carrusel de imágenes,
   carrusel de testimonios.
   Escucha shopify:section:load para re-inicializar en el theme editor.
*/
(function () {
  'use strict';

  /* ── Scroll reveal ─────────────────────────────────────────
     Añade .rk-in a los elementos .rk-reveal cuando entran al viewport.
  ────────────────────────────────────────────────────────── */
  function initReveal(root) {
    root = root || document;
    var els = root.querySelectorAll('.rk-reveal:not(.rk-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rk-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rk-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '-40px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── FAQ accordion ─────────────────────────────────────────
     Usa data-rk-faq como wrapper. Toggle .rk-open en cada ítem.
  ────────────────────────────────────────────────────────── */
  function initFAQ(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-faq]:not([data-rk-faq-init])').forEach(function (faqEl) {
      faqEl.setAttribute('data-rk-faq-init', '1');
      faqEl.querySelectorAll('.rk-faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item   = btn.closest('.rk-faq-item');
          var isOpen = item.classList.contains('rk-open');
          faqEl.querySelectorAll('.rk-faq-item.rk-open').forEach(function (i) {
            i.classList.remove('rk-open');
            i.querySelector('.rk-faq-q').setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('rk-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ── Tabs ──────────────────────────────────────────────────
     Wrapper: data-rk-tabs
     Tabs: .rk-tab (se activan con .rk-active)
     Paneles: .rk-tab-panel (se muestran con .rk-active)
     Los tabs deben tener data-rk-tab="id" y los paneles id="id".
  ────────────────────────────────────────────────────────── */
  function initTabs(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-tabs]:not([data-rk-tabs-init])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-tabs-init', '1');
      var tabs   = wrapper.querySelectorAll('.rk-tab');
      var panels = wrapper.querySelectorAll('.rk-tab-panel');

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('rk-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) { p.classList.remove('rk-active'); });

          tab.classList.add('rk-active');
          tab.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('rk-active');
        });
      });

      // Activa el primer tab si ninguno está activo
      if (!wrapper.querySelector('.rk-tab.rk-active') && tabs.length) {
        tabs[0].classList.add('rk-active');
        tabs[0].setAttribute('aria-selected', 'true');
        if (panels[0]) panels[0].classList.add('rk-active');
      }
    });
  }

  /* ── Testimonials carousel ─────────────────────────────────
     Wrapper: data-rk-carousel="testimonials"
     Slides: .rk-carousel-slide → activo con .rk-active
     Flechas: data-rk-prev / data-rk-next
  ────────────────────────────────────────────────────────── */
  function initTestimonialsCarousel(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-carousel="testimonials"]:not([data-rk-ci])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-ci', '1');
      var slides = wrapper.querySelectorAll('.rk-carousel-slide');
      if (!slides.length) return;

      var idx = 0;

      function show(n) {
        slides.forEach(function (s) { s.classList.remove('rk-active'); });
        slides[n].classList.add('rk-active');
      }
      show(0);

      var prevBtn = wrapper.querySelector('[data-rk-prev]');
      var nextBtn = wrapper.querySelector('[data-rk-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          idx = (idx - 1 + slides.length) % slides.length;
          show(idx);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          idx = (idx + 1) % slides.length;
          show(idx);
        });
      }
    });
  }

  /* ── Image carousel (slides con imagen) ────────────────────
     Wrapper: data-rk-carousel="images"
     Track: .rk-img-carousel-track
     Slides: .rk-img-slide
     Flechas: data-rk-prev / data-rk-next
     Dots: .rk-img-carousel-dot con data-rk-slide="n"
     Autoplay: data-rk-autoplay="ms" en el wrapper
  ────────────────────────────────────────────────────────── */
  function initImageCarousel(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-carousel="images"]:not([data-rk-ci])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-ci', '1');
      var track  = wrapper.querySelector('.rk-img-carousel-track');
      var slides = wrapper.querySelectorAll('.rk-img-slide');
      var dots   = wrapper.querySelectorAll('.rk-img-carousel-dot');
      if (!slides.length || !track) return;

      var idx   = 0;
      var total = slides.length;
      var timer = null;
      var autoplayMs = parseInt(wrapper.dataset.rkAutoplay, 10) || 0;

      function go(n) {
        idx = ((n % total) + total) % total;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        dots.forEach(function (d, i) {
          d.classList.toggle('rk-active', i === idx);
        });
      }

      go(0);

      var prevBtn = wrapper.querySelector('[data-rk-prev]');
      var nextBtn = wrapper.querySelector('[data-rk-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); resetTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); resetTimer(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.dataset.rkSlide, 10));
          resetTimer();
        });
      });

      function resetTimer() {
        if (!autoplayMs) return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, autoplayMs);
      }

      if (autoplayMs) resetTimer();

      /* ── Swipe táctil + drag de mouse en el image carousel ── */
      var touchStartX = 0;
      wrapper.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      wrapper.addEventListener('touchend', function (e) {
        var delta = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 48) { go(delta > 0 ? idx + 1 : idx - 1); resetTimer(); }
      }, { passive: true });

      var dragStartX = 0, isDragging = false;
      wrapper.addEventListener('mousedown', function (e) {
        dragStartX = e.clientX; isDragging = true;
      });
      wrapper.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var delta = dragStartX - e.clientX;
        if (Math.abs(delta) > 48) { go(delta > 0 ? idx + 1 : idx - 1); resetTimer(); }
      });
      wrapper.addEventListener('mouseleave', function () { isDragging = false; });
    });
  }

  /* ── Paged carousel (gallery) ─────────────────────────────
     Wrapper: data-rk-carousel="paged"
     Slides:  .rk-paged-slide  (visibilidad toggle con .rk-active)
     Flechas: data-rk-prev / data-rk-next
     Dots:    .rk-img-carousel-dot con data-rk-slide="n"
     Soporta: swipe táctil + drag de mouse
  ────────────────────────────────────────────────────────── */
  function initPagedCarousel(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-carousel="paged"]:not([data-rk-ci])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-ci', '1');
      var slides = wrapper.querySelectorAll('.rk-paged-slide');
      var dots   = wrapper.querySelectorAll('.rk-img-carousel-dot');
      if (!slides.length) return;

      var idx = 0;

      function show(n) {
        idx = ((n % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('rk-active', i === idx);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('rk-active', i === idx);
        });
      }
      show(0);

      var prevBtn = wrapper.querySelector('[data-rk-prev]');
      var nextBtn = wrapper.querySelector('[data-rk-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.rkSlide, 10));
        });
      });

      /* ── Swipe táctil ── */
      var touchStartX = 0;
      wrapper.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      wrapper.addEventListener('touchend', function (e) {
        var delta = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 48) show(delta > 0 ? idx + 1 : idx - 1);
      }, { passive: true });

      /* ── Drag de mouse ── */
      var dragStartX = 0;
      var isDragging = false;
      wrapper.addEventListener('mousedown', function (e) {
        dragStartX  = e.clientX;
        isDragging  = true;
      });
      wrapper.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var delta = dragStartX - e.clientX;
        if (Math.abs(delta) > 48) show(delta > 0 ? idx + 1 : idx - 1);
      });
      wrapper.addEventListener('mouseleave', function () { isDragging = false; });
    });
  }

  /* ── Swipe carousel (productos) ────────────────────────────
     Wrapper: data-rk-carousel="swipe"
     Track:   .rk-swipe-track  (flex + overflow-x + scroll-snap)
     Items:   .rk-swipe-item
     Flechas: data-rk-prev / data-rk-next (scroll por un item)
     Soporta: scroll táctil nativo + drag de mouse en desktop
  ────────────────────────────────────────────────────────── */
  function initSwipeCarousel(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-carousel="swipe"]:not([data-rk-ci])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-ci', '1');
      var track = wrapper.querySelector('.rk-swipe-track');
      if (!track) return;

      function itemStep() {
        var item = track.querySelector('.rk-swipe-item');
        if (!item) return 0;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
        return item.offsetWidth + gap;
      }

      var prevBtn = wrapper.querySelector('[data-rk-prev]');
      var nextBtn = wrapper.querySelector('[data-rk-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -itemStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: itemStep(), behavior: 'smooth' });
      });

      /* ── Drag de mouse ── */
      var startX = 0, startScroll = 0, dragging = false;

      track.addEventListener('mousedown', function (e) {
        dragging    = true;
        startX      = e.pageX;
        startScroll = track.scrollLeft;
        track.classList.add('rk-dragging');
        e.preventDefault();
      });
      document.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('rk-dragging');
      });
      track.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        track.scrollLeft = startScroll - (e.pageX - startX);
      });
      track.addEventListener('mouseleave', function () {
        dragging = false;
        track.classList.remove('rk-dragging');
      });
    });
  }

  /* ── Anchor nav — activa el enlace de la sección visible ───
     Lee .rk-nav-anchor-link[href="#id"] y activa .rk-active
     cuando la sección con ese id entra en viewport.
     También: click → scroll suave (scroll-behavior: smooth).
  ────────────────────────────────────────────────────────── */
  function initAnchorNav() {
    var navs = document.querySelectorAll('.rk-nav-anchor');
    if (!navs.length) return;

    /* Flechas mobile — scroll del track */
    navs.forEach(function (nav) {
      var track = nav.querySelector('.rk-nav-anchor-track');
      var prev  = nav.querySelector('[data-rk-nav-prev]');
      var next  = nav.querySelector('[data-rk-nav-next]');
      if (track && prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -120, behavior: 'smooth' });
      });
      if (track && next) next.addEventListener('click', function () {
        track.scrollBy({ left: 120, behavior: 'smooth' });
      });
    });

    if (!window.IntersectionObserver) return;

    var allLinks = [];
    navs.forEach(function (nav) {
      nav.querySelectorAll('.rk-nav-anchor-link').forEach(function (link) {
        allLinks.push(link);
        link.addEventListener('click', function (e) {
          var id = link.getAttribute('href').replace('#', '');
          var target = document.getElementById(id);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    });

    if (!allLinks.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        allLinks.forEach(function (link) {
          var matches = link.getAttribute('href') === '#' + id;
          link.classList.toggle('rk-active', matches);
        });
      });
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });

    allLinks.forEach(function (link) {
      var id = link.getAttribute('href').replace('#', '');
      var section = id ? document.getElementById(id) : null;
      if (section) observer.observe(section);
    });
  }

  /* ── Gallery carousel (multi-col scroll-snap) ──────────────
     Wrapper: data-rk-carousel="gallery"
     Track:   .rk-gal-scroll-track  (flex + overflow-x + scroll-snap)
     Items:   .rk-gal-scroll-item
     Dots:    .rk-img-carousel-dot con data-rk-slide="n"
     Soporta: drag de mouse + scroll táctil nativo + IntersectionObserver dots
  ────────────────────────────────────────────────────────── */
  function initGalleryCarousel(root) {
    root = root || document;
    root.querySelectorAll('[data-rk-carousel="gallery"]:not([data-rk-ci])').forEach(function (wrapper) {
      wrapper.setAttribute('data-rk-ci', '1');
      var track = wrapper.querySelector('.rk-gal-scroll-track');
      var dots  = wrapper.querySelectorAll('.rk-img-carousel-dot');
      if (!track) return;

      /* Drag de mouse */
      var startX = 0, startScroll = 0, dragging = false;
      track.addEventListener('mousedown', function (e) {
        dragging = true; startX = e.pageX; startScroll = track.scrollLeft;
        track.classList.add('rk-dragging'); e.preventDefault();
      });
      document.addEventListener('mouseup', function () {
        if (!dragging) return; dragging = false; track.classList.remove('rk-dragging');
      });
      track.addEventListener('mousemove', function (e) {
        if (!dragging) return; track.scrollLeft = startScroll - (e.pageX - startX);
      });
      track.addEventListener('mouseleave', function () {
        dragging = false; track.classList.remove('rk-dragging');
      });

      /* Click en dot → scroll al item correspondiente */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.dataset.rkSlide, 10);
          var items = track.querySelectorAll('.rk-gal-scroll-item');
          if (items[idx]) {
            track.scrollTo({ left: items[idx].offsetLeft, behavior: 'smooth' });
          }
        });
      });

      /* IntersectionObserver → activa dot cuando el item entra en vista */
      if (!window.IntersectionObserver) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var items = Array.from(track.querySelectorAll('.rk-gal-scroll-item'));
          var idx = items.indexOf(entry.target);
          if (idx >= 0) {
            dots.forEach(function (d, i) { d.classList.toggle('rk-active', i === idx); });
          }
        });
      }, { root: track, threshold: 0.5 });

      track.querySelectorAll('.rk-gal-scroll-item').forEach(function (item) {
        observer.observe(item);
      });
    });
  }

  /* ── Hash tabs ─────────────────────────────────────────────
     Lee window.location.hash al cargar la página.
     Si coincide con data-rk-hash de un .rk-tab, lo activa.
     Mapeo: #bautizo → data-rk-hash="bautizo"
            #primera-comunion → data-rk-hash="primera-comunion"
     Se aplica a todos los [data-rk-tabs] de la página a la vez.
  ────────────────────────────────────────────────────────── */
  function initHashTabs() {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;

    document.querySelectorAll('[data-rk-tabs]').forEach(function (wrapper) {
      var tabs   = wrapper.querySelectorAll('.rk-tab');
      var panels = wrapper.querySelectorAll('.rk-tab-panel');
      var matched = false;

      tabs.forEach(function (tab, i) {
        if (tab.dataset.rkHash === hash) {
          tabs.forEach(function (t) {
            t.classList.remove('rk-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) { p.classList.remove('rk-active'); });

          tab.classList.add('rk-active');
          tab.setAttribute('aria-selected', 'true');
          if (panels[i]) panels[i].classList.add('rk-active');
          matched = true;
        }
      });
    });
  }

  /* ── Init global ───────────────────────────────────────────
  ────────────────────────────────────────────────────────── */
  function init(root) {
    initReveal(root);
    initFAQ(root);
    initTabs(root);
    initTestimonialsCarousel(root);
    initImageCarousel(root);
    initPagedCarousel(root);
    initSwipeCarousel(root);
    initGalleryCarousel(root);
    if (!root || root === document) { initHashTabs(); initAnchorNav(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init cuando el editor de Shopify carga una sección
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

}());
